export const runtimeEnvironment = {
  BUILD_NUMBER: '40f81b23-edfe-47b7-87a2-322ff756b60e',
  SENTRY_ENABLED: true,
};
